<!-- 理光资料后补审批 -->
<template>
	<div class="process-page">
		<div class="create-section">
			<div class="process-item">
				<p>资料候补说明</p>
				<el-input readonly placeholder="请输入内容" v-model="lastIntro"></el-input>
			</div>
			<el-button v-if="isPrepaid" class="mt10" type="primary" @click="handleCheckExpress">查看实物寄件信息</el-button>
			<div class="process-item">
				<p>审批批注</p>
				<el-input placeholder="请输入内容" v-model="remark"></el-input>
			</div>
			<div class="create-footer">
				<el-button type="danger" @click="handleSubmit('-8')">拒绝</el-button>
				<el-button type="primary" @click="handleSubmit('9')">提交</el-button>
			</div>
		</div>
		<ShowAddressInfo ref="showAddressInfo"></ShowAddressInfo>
		<!-- 流程信息 -->
		<CommonCollapse1 ref="collapse1" />
	</div>
</template>
<script>
import { processInfo } from "@/api/claim";
import ShowAddressInfo from "../components/showAddressInfo.vue";
import CommonCollapse1 from "../components/CommonCollapse1.vue";
export default {
	components: {
		ShowAddressInfo,
		CommonCollapse1,
	},
	data() {
		return {
			repairType: "",
			createTime: "",
			// 订购信息
			partTitleObj: {
				1: "机器零件",
				2: "订购零件",
				3: "商品(耗材)",
			},
			isPrepaid: false,
			faultyExpress: null,
			mainId: "",
			lastIntro: "",
			remark: "",
		};
	},
	mounted() {
		this.getClaimWarrantyInfo();
	},
	methods: {
		// 获取单个索赔信息
		getClaimWarrantyInfo() {
			// 获取单个索赔信息
			const claimId = sessionStorage.getItem("claimId") || this.$route.query.claimId;
			let self = this;
			processInfo(claimId, true)
				.then((r) => {
					if (r.code == "0") {
						sessionStorage.setItem("claimId", r.data.id);
						sessionStorage.setItem("repairType", r.data.repairType);
						sessionStorage.setItem("claimInfo", JSON.stringify(r.data));
						self.repairType = r.data.repairType;
						self.createTime = r.data.currentAudit.createTime;
						self.mainId = r.data.id;
						self.lastIntro = r.data.partsClaimWarranty.lastIntro;
						self.faultyExpress = r.data.partsClaimWarranty.prepaidExpress;
						r.data.partsClaimWarranty.isPrepaid == 1 ? (self.isPrepaid = true) : (self.isPrepaid = false);
					} else {
						self.$message.error(r.msg);
					}
				})
				.catch((error) => {
					console.log(error);
				});
		},
		// 提交
		handleSubmit(type) {
			if (this.remark == "") {
				this.$message.error("请填写审批批注");
				return;
			}
			let msg = type == "-8" ? "确定拒绝此次资料后补审批吗?" : "确定通过此次资料候补申请吗?";
			this.$confirm(msg, "", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
			})
				.then(() => {
					this.claimWarrantyAuditAdd(type);
				})
				.catch(() => {});
		},
		// 提交接口
		claimWarrantyAuditAdd(auditStatus) {
			let self = this;
			const params = {
				relatedId: self.mainId,
				auditStatus: auditStatus,
				remark: self.remark,
			};
			self.$request.post("claimWarrantyAuditAdd", true, params, function (r) {
				if (r.code == "0") {
					self.$message({
						message: "操作成功",
						type: "success",
					});
					self.$router.push({
						name: "claimReviewList",
					});
				} else {
					self.$message.error(r.msg);
				}
			});
		},
		// 点击查看实物寄件信息
		handleCheckExpress() {
			this.$refs.showAddressInfo.init(this.faultyExpress);
		},
	},
};
</script>
<style lang="scss" scoped>
.process-page ::v-deep .el-collapse-item__header {
	height: 60px;
	line-height: unset;
}
.title-content {
	width: 100%;
}
.title-box {
	display: flex;
	&:first-child {
		margin-bottom: 10px;
		span {
			font-size: 1rem;
			font-weight: 400;
			line-height: 1.5;
			letter-spacing: 0.00938em;
		}
	}
	span {
		flex: 1;
		&:last-child {
			text-align: right;
			margin-right: 20px;
		}
	}
}

.create-section {
	border-top: 1px solid #ddd;
	padding-top: 10px 20px;
}
.create-footer {
	text-align: right;
	margin-top: 20px;
	padding: 20px;
	border-top: 1px solid #ddd;
}
.process-item {
	margin-top: 10px;
	p {
		font-size: 1rem;
		font-weight: 400;
		line-height: 1.75;
		letter-spacing: 0.00938em;
		margin-bottom: 10px;
	}
	.el-select {
		width: 100%;
	}
}
.t-r {
	text-align: right;
}
.mt10 {
	margin-top: 10px;
}
.mb20 {
	margin-bottom: 20px;
}
</style>
